import { schema } from 'normalizr';

const projectSchema = new schema.Entity('projects', {}, {
  idAttribute: project => project.external_id
});

const attachmentsSchema = new schema.Entity('attachments', {
  owner: projectSchema
}, {
  idAttribute: attachment => attachment.value
});

export const projectSchemas = {
  PROJECT: projectSchema,
  PROJECT_ARRAY: [projectSchema],
  ATTACHMENT: attachmentsSchema,
  ATTACHMENTS_ARRAY: [attachmentsSchema]
};
